/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Not_FoundInputs */

const th_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การประชุมนี้ไม่ใช่ของคุณ ขอให้ผู้ที่เริ่มการประชุมเชิญคุณ`)
};

const en_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This meeting is not one of yours. Ask whoever started it to invite you.`)
};

const ja_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このミーティングはあなたのものではありません。始めた人に招待してもらってください。`)
};

const zh_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这场会议不属于你。请让主办者邀请你。`)
};

const es_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta reunión no es tuya. Pide a quien la creó que te invite.`)
};

const pt_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta reunião não é sua. Peça a quem a criou para convidar você.`)
};

const id_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertemuan ini bukan milik Anda. Minta penyelenggaranya mengundang Anda.`)
};

const fr_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette réunion n’est pas la vôtre. Demandez à son organisateur de vous inviter.`)
};

const tl_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi sa iyo ang mitingang ito. Hilingin sa organizer na anyayahan ka.`)
};

const vi_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuộc họp này không phải của bạn. Hãy nhờ người tổ chức mời bạn.`)
};

const ko_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 회의는 회원님의 것이 아닙니다. 주최자에게 초대를 요청하세요.`)
};

const de_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Meeting gehört nicht zu deinen. Bitte den Veranstalter, dich einzuladen.`)
};

const ru_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта встреча не ваша. Попросите организатора пригласить вас.`)
};

const tr_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu toplantı sizin değil. Düzenleyenden sizi davet etmesini isteyin.`)
};

const it_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa riunione non è tua. Chiedi all'organizzatore di invitarti.`)
};

const pl_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To spotkanie nie należy do ciebie. Poproś organizatora o zaproszenie.`)
};

const uk_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця зустріч не ваша. Попросіть організатора запросити вас.`)
};

const hi_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह बैठक आपकी नहीं है। आयोजक से आपको आमंत्रित करने को कहें।`)
};

const ar_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الاجتماع ليس لك. اطلب من المنظّم أن يدعوك.`)
};

const ms_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesyuarat ini bukan milik anda. Minta penganjur menjemput anda.`)
};

const bn_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই সভাটি আপনার নয়। আয়োজককে আপনাকে আমন্ত্রণ জানাতে বলুন।`)
};

const zh_tw2_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這場會議不屬於你。請主辦者邀請你。`)
};

const zh_hk2_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這場會議不屬於你。請主辦者邀請你。`)
};

const ur_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ ملاقات آپ کی نہیں۔ منتظم سے کہیں کہ آپ کو مدعو کریں۔`)
};

const fa_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این جلسه از آنِ شما نیست. از برگزارکننده بخواهید دعوت‌تان کند.`)
};

const sw_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkutano huu si wako. Muombe mwandalizi akualike.`)
};

const nl_meeting_not_found = /** @type {(inputs: Meeting_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit gesprek is niet van jou. Vraag de organisator je uit te nodigen.`)
};

/**
* | output |
* | --- |
* | "This meeting is not one of yours. Ask whoever started it to invite you." |
*
* @param {Meeting_Not_FoundInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_not_found = /** @type {((inputs?: Meeting_Not_FoundInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Not_FoundInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_not_found(inputs)
	if (locale === "ja") return ja_meeting_not_found(inputs)
	if (locale === "zh") return zh_meeting_not_found(inputs)
	if (locale === "es") return es_meeting_not_found(inputs)
	if (locale === "pt") return pt_meeting_not_found(inputs)
	if (locale === "id") return id_meeting_not_found(inputs)
	if (locale === "fr") return fr_meeting_not_found(inputs)
	if (locale === "tl") return tl_meeting_not_found(inputs)
	if (locale === "vi") return vi_meeting_not_found(inputs)
	if (locale === "ko") return ko_meeting_not_found(inputs)
	if (locale === "de") return de_meeting_not_found(inputs)
	if (locale === "ru") return ru_meeting_not_found(inputs)
	if (locale === "tr") return tr_meeting_not_found(inputs)
	if (locale === "it") return it_meeting_not_found(inputs)
	if (locale === "pl") return pl_meeting_not_found(inputs)
	if (locale === "uk") return uk_meeting_not_found(inputs)
	if (locale === "hi") return hi_meeting_not_found(inputs)
	if (locale === "ar") return ar_meeting_not_found(inputs)
	if (locale === "ms") return ms_meeting_not_found(inputs)
	if (locale === "bn") return bn_meeting_not_found(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_not_found(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_not_found(inputs)
	if (locale === "ur") return ur_meeting_not_found(inputs)
	if (locale === "fa") return fa_meeting_not_found(inputs)
	if (locale === "sw") return sw_meeting_not_found(inputs)
	if (locale === "nl") return nl_meeting_not_found(inputs)
	return en_meeting_not_found(inputs)
});